import { render } from "./Detail.vue?vue&type=template&id=cd38dd7a&ts=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=cd38dd7a&lang=css"

import exportComponent from "D:\\wamp64\\www\\driver.total.cz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__